<template>
  <div>
    <MenuItems :user="this.user" :menuSelected="menuSelected" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="menuSelected" />
    </div>
  </div>
</template>
<script>
import MenuItems from "@/components/cms-mkt/MenuItems.vue";

export default {
  name: "Menu",
  props: {
    user: Object,
    menuSelected: Object,
  },
  components:{
    MenuItems
  }
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
